
import { UserService } from './userService.js';

export const AdminUI = {
    async init(currentUser) {
        // Solo mostrar si es Abogado Titular (Master Admin o asignado)
        if (currentUser.role !== 'abogado_titular') return;

        this.renderAdminButton();
    },

    renderAdminButton() {
        const nav = document.querySelector('nav') || document.body;
        const btn = document.createElement('button');
        btn.id = 'admin-panel-btn';
        btn.innerHTML = '⚙️ Admin Usuarios';
        btn.className = 'btn-secondary';
        btn.style.marginLeft = '10px';
        btn.onclick = () => this.openAdminModal();

        // Intentar insertar en el Header Principal (Prioridad)
        const headerLogout = document.getElementById('btn-logout-header');
        if (headerLogout) {
            btn.className = 'btn-outline'; // Match header style
            btn.style.color = 'var(--primary-gold)';
            btn.style.borderColor = 'var(--primary-gold)';
            btn.style.marginRight = '10px';
            btn.innerHTML = '⚙️ ADMIN'; // Shorter text for header
            headerLogout.parentNode.insertBefore(btn, headerLogout);
            return;
        }

        // Fallback: Sidebar (si estamos en vista móvil o tablet)
        const sidebarLogout = document.getElementById('logout-btn-sidebar');
        if (sidebarLogout) {
            btn.style.width = '100%';
            btn.style.marginTop = '1rem';
            sidebarLogout.parentNode.insertBefore(btn, sidebarLogout);
            return;
        }

        // Fallback final
        document.body.appendChild(btn);
    },

    async openAdminModal() {
        // Crear modal si no existe
        let modal = document.getElementById('admin-modal');
        if (!modal) {
            modal = document.createElement('div');
            modal.id = 'admin-modal';
            modal.className = 'modal';
            modal.innerHTML = `
                <div class="modal-content" style="max-width: 800px;">
                    <span class="close-btn" onclick="document.getElementById('admin-modal').style.display='none'">&times;</span>
                    <h2>👥 Administración de Usuarios</h2>
                    <div id="admin-users-list" class="user-list-container">
                        <p>Cargando usuarios...</p>
                    </div>
                </div>
            `;
            document.body.appendChild(modal);
        }

        modal.style.display = 'block';
        await this.loadUsers();
    },

    async loadUsers() {
        const container = document.getElementById('admin-users-list');
        container.innerHTML = '<div class="spinner"></div> Cargando...';

        try {
            const users = await UserService.getAllUsers();

            if (users.length === 0) {
                container.innerHTML = '<p>No se encontraron usuarios.</p>';
                return;
            }

            let html = `
                <table style="width: 100%; border-collapse: collapse; margin-top: 1rem;">
                    <thead>
                        <tr style="background: #f8f9fa; text-align: left;">
                            <th style="padding: 10px;">Usuario</th>
                            <th style="padding: 10px;">Email</th>
                            <th style="padding: 10px;">Rol</th>
                            <th style="padding: 10px;">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            users.forEach(user => {
                const isMe = user.email === 'alberto.rampoldi@gmail.com'; // Master Admin protection
                html += `
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="padding: 10px; display: flex; align-items: center; gap: 10px;">
                            <img src="${user.photoURL || 'https://via.placeholder.com/30'}" style="width: 30px; height: 30px; border-radius: 50%;">
                            ${user.displayName || 'Sin nombre'}
                        </td>
                        <td style="padding: 10px;">${user.email}</td>
                        <td style="padding: 10px;">
                            <select id="role-${user.uid}" ${isMe ? 'disabled' : ''} style="padding: 5px; border-radius: 4px;">
                                <option value="abogado_titular" ${user.role === 'abogado_titular' ? 'selected' : ''}>Abogado Titular</option>
                                <option value="abogado_asociado" ${user.role === 'abogado_asociado' ? 'selected' : ''}>Abogado Asociado</option>
                                <option value="cliente" ${user.role === 'cliente' ? 'selected' : ''}>Cliente</option>
                                <option value="inactivo" ${user.role === 'inactivo' ? 'selected' : ''}>Inactivo (Bloqueado)</option>
                            </select>
                        </td>
                        <td style="padding: 10px;">
                            ${!isMe ? `<button onclick="AdminUI.saveRole('${user.uid}')" class="btn-primary" style="padding: 5px 10px; font-size: 0.8rem;">Guardar</button>` : '<span style="color: #999;">Master</span>'}
                        </td>
                    </tr>
                `;
            });

            html += '</tbody></table>';
            container.innerHTML = html;

            // Expose function globally for the onclick handler
            window.AdminUI = this;

        } catch (error) {
            console.error(error);
            container.innerHTML = `<p style="color: red;">Error cargando usuarios: ${error.message}</p>`;
        }
    },

    async saveRole(uid) {
        const select = document.getElementById(`role-${uid}`);
        const newRole = select.value;
        const btn = select.parentElement.nextElementSibling.querySelector('button');

        const originalText = btn.innerText;
        btn.innerText = 'Guardando...';
        btn.disabled = true;

        try {
            await UserService.updateUserProfile(uid, { role: newRole });
            alert('✅ Rol actualizado correctamente');
        } catch (error) {
            alert('❌ Error actualizando rol: ' + error.message);
        } finally {
            btn.innerText = originalText;
            btn.disabled = false;
        }
    }
};
